import { IApiService } from "@/interfaces/services/IApiService";
import { ApiRequestConfig, apiService } from "./api.service";
import { IAllComments } from "@/interfaces/entities/comments";

class CommentsService {
    api: IApiService<ApiRequestConfig>;


    constructor(api: IApiService<ApiRequestConfig>) {
        this.api = api;
    }

    async getAllComments(pageNumber: number, config?: ApiRequestConfig) {
        const result = await this.api.get<{ data: IAllComments[]; pageCount: number }>(
            `/comments?page[size]=10&page[number]=${pageNumber}&sort[createdAt]=DESC`,
            config,
        );
        return result;
    }
      async getOneBlogComments( id:number,pageNumber: number, config?: ApiRequestConfig) {
        const result = await this.api.get<{ data: IAllComments[]; pageCount: number }>(
            `/comments/blog/${id}?page[size]=10&page[number]=${pageNumber}&sort[createdAt]=DESC`,
            config,
        );
        return result;
    }

    async changeStatus(id: number, status: string, config?: ApiRequestConfig) {
        return await this.api.patch<IAllComments>(
            `/comments/status/${id}`,
            { status },
            config,
        );
    }
    
}

export const commentService = new CommentsService(apiService);
